export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5111.919f00dd.jpg";